const variablePrefix = ':';

const isParameterized = testString => testString.indexOf(variablePrefix) > -1;

const getPatternMatch = (pattern, urlPath) => {
  let matches = true;
  const params = {};
  const urlParts = urlPath.split('/');
  const patternParts = pattern.split('/');
  if (urlParts.length !== patternParts.length) {
    matches = false;
    return { matches, params };
  }
  for (let i = 0; i < patternParts.length; i += 1) {
    if (isParameterized(patternParts[i])) {
      const parameter = patternParts[i].replace(variablePrefix, '');
      const value = urlParts[i];
      params[parameter] = value;
    } else if (patternParts[i] !== urlParts[i]) {
      matches = false;
      break;
    }
  }
  return {
    matches,
    params
  };
};

// given a browser URL path, returns details about how to construct the route
export const urlDeconstructor = (urlMap, urlPath) => {
  const output = {
    key: undefined,
    pattern: undefined,
    params: {},
    isSimple: undefined
  };
  const keys = Object.keys(urlMap);
  for (let i = 0; i < keys.length; i += 1) {
    const pattern = urlMap[keys[i]];
    const { matches, params } = getPatternMatch(pattern, urlPath);
    if (matches) {
      output.key = keys[i];
      output.pattern = pattern;
      output.params = params;
      output.isSimple = !isParameterized(pattern);
      break;
    }
  }
  return output;
};

export const urlConstructor = (urlMapString, params = {}) => {
  let url = urlMapString;
  const regex = /:([\w]+)/gi;
  const matches = urlMapString.match(regex);
  if (matches) {
    matches.forEach((m) => {
      const key = m.substring(1);
      const paramValue = params[key];
      if (paramValue === undefined) {
        throw new Error(`urlConstructionError @ ${urlMapString}; missing param key "${key}"`);
      }
      url = url.replace(`:${key}`, paramValue);
    });
  }
  return url;
};
